import { log } from '@/services/log'

export default function ({ path, meta: { storeFn } }) {
  const isListingPage = !path.includes('mono') || !path.includes('new')

  if (isListingPage) {
    if (storeFn) {
      const store = storeFn()
      const fields = store.allFields.filter((d) => d.visible)
      const sortBy = store.sortBy

      let value = sortBy || ''
      if (value?.length === 0) {
        value = fields.find((d) => d?.defaultSortBy)?.key
      }
      if (!value) {
        value = fields.find((d) => d.key === 'lastTimestamp')?.key
      }
      if (!value) {
        value = fields.find((d) => d.key === 'lastModifiedTimestamp')?.key
      }
      if (!value) {
        value = fields.find((d) => d.key === 'name')?.key
      }
      if (!value) {
        value = fields.find((d) => d.key === 'createdTimestamp')?.key
      }

      const defaultSortBy = store.viewMode === 'history' ? 'createdTimestamp' : value || ''
      store.sortBy = defaultSortBy
      log('Default sorting key:', defaultSortBy)
    }
  }
  return
}
